import PaginationControls from "../../../../../../components/base/PaginationControls";

interface GeofencePaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function GeofencePagination({
  currentPage,
  totalPages,
  onPageChange,
}: GeofencePaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <PaginationControls
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
    />
  );
}
